module.exports = __webpack_public_path__ + "assets/77f5ebfbeab4f0316e282c9910005089.png";